'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AuthPolicyCreatePage, IDP_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/idp/_layout/policies/new/')({
  component: () => <AuthPolicyCreatePage paths={IDP_AUTH_POLICY_PATHS} />
});